import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDownIcon } from "@heroicons/react/solid";

const languages = [
  {
    code: "it",
    label: "ITA",
    flag: (
      <svg className="w-5 h-5 rounded-sm" viewBox="0 0 3 2">
        <rect width="1" height="2" x="0" fill="#008C45" />
        <rect width="1" height="2" x="1" fill="#F4F9FF" />
        <rect width="1" height="2" x="2" fill="#CD212A" />
      </svg>
    ),
  },
  {
    code: "en",
    label: "ENG",
    flag: (
      <svg className="w-5 h-5 rounded-sm" viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="30" fill="#012169" />
        <path d="M0 0 L60 30 M60 0 L0 30" stroke="#fff" strokeWidth="6" />
        <path d="M0 0 L60 30 M60 0 L0 30" stroke="#C8102E" strokeWidth="4" />
        <path d="M30 0 V30 M0 15 H60" stroke="#fff" strokeWidth="10" />
        <path d="M30 0 V30 M0 15 H60" stroke="#C8102E" strokeWidth="6" />
      </svg>
    ),
  },
];

const LanguageSelector = ({ isMobile = false }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  const getCurrentLabel = () => {
    const current = languages.find((l) => l.code === i18n.language);
    return current ? current.label : "—";
  };

  const getCurrentFlag = () => {
    const current = languages.find((l) => l.code === i18n.language);
    return current ? current.flag : null;
  };

  return (
    <div className="relative text-white tracking-wider">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-2 hover:opacity-80 transition-opacity
    ${isMobile ? "scale-90" : ""}
  `}
        aria-label="Select language"
      >
        {getCurrentFlag()}
        <span className="font-semibold">{getCurrentLabel()}</span>
        {isMobile ? (
          <ChevronDownIcon
            className={`w-4 h-4 opacity-80 transition-transform ${open ? "rotate-180" : ""}`}
            style={{ transform: open ? "rotate(0deg)" : "rotate(180deg)" }}
          />
        ) : (
          <ChevronDownIcon
            className={`w-4 h-4 opacity-80 transition-transform ${open ? "rotate-180" : ""}`}
          />
        )}
      </button>
      {open && (
        <div
          className={`
    absolute
    ${isMobile ? "bottom-full mb-3" : "mt-2"}
    w-40
    border border-white/20
    rounded-md
    bg-black/20 backdrop-blur-sm
    overflow-hidden
    animate-[fadeIn_120ms_ease-out]
    left-1/2 -translate-x-1/2
  `}
        >
          {languages.map((lng, index) => {
            const active = i18n.language === lng.code;

            return (
              <div key={lng.code}>
                <button
                  onClick={() => changeLanguage(lng.code)}
                  className={`
              flex items-center gap-3
              px-3 py-2
              w-full text-left text-base
              transition rounded-none
              ${active ? "bg-white/20 text-white font-semibold" : "text-gray-200 hover:bg-white/10"}
            `}
                >
                  {lng.flag}
                  <span>{lng.label}</span>
                </button>
                {index < languages.length - 1 &&
                  !active &&
                  i18n.language !== languages[index + 1].code && (
                    <div className="h-px bg-white/10 mx-3" />
                  )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
